import type { RegistryState, StaffProfilePatch } from '../../data/types';
import { withAudit } from '../helpers';

export function updateStaffProfile(
  state: RegistryState,
  action: { userId: string; patch: StaffProfilePatch },
): RegistryState {
  const user = state.users.find((item) => item.id === action.userId);
  if (!user) return state;
  const next: RegistryState = {
    ...state,
    users: state.users.map((item) =>
      item.id === action.userId ? { ...item, ...action.patch } : item,
    ),
  };
  return withAudit(
    next,
    'Staff profile updated',
    action.patch.name ?? user.name,
    'Applies to deals set up from now on',
  );
}
